const Styles = {
    'FilterField': 'FilterField_FilterField--3aac4b23',
    'fieldLabel': 'FilterField_fieldLabel--8515f2ba',
    'filterContainer': 'FilterField_filterContainer--aa48aa9f'
};

export default Styles;